<template>
    <div class="ds-background-primary p-2 position-relative">
        <div class="container d-flex justify-content-between align-items-center">
            <div class="d-flex flex-row">
                <h3 class="mr-5">
                    <router-link to="/">
                        <img src="@/assets/logo-white.png" alt="ELSA" width="140px"/>
                    </router-link>
                </h3>
                <router-link to="/" class="ds-btn mr-5 align-self-center" tag="button">Sākums</router-link>
            </div>
            <div>
                <button class="ds-btn mr-5" @click="handleCompanyMainPage" v-if="$route.params.companyId && currentUser.isAdmin">Uzņēmums</button>
                <button class="ds-btn mr-5" @click="handleCompanyOvpJobConditionTemplates" v-if="$route.params.companyId && currentUser.isAdmin">OVP</button>
                <button class="ds-btn mr-5" @click="handleCompanyOvp" v-if="currentUser.isManager">OVP</button>
                <button class="ds-btn mr-5" @click="handleOvpJobConditionTemplates" v-if="currentUser.isAdmin">OVP darba apstākļu šabloni</button>
                <button class="ds-btn mr-5" @click="handleCategoryTemplates" v-if="currentUser.isAdmin">Kategoriju šabloni</button>
                <router-link v-if="currentUser.isUser" to="/profils" class="ds-btn mr-5">Profils</router-link>

                <template v-if="currentUser.isManager">
                    <!-- <router-link to="/ovp" class="ds-btn mr-5">OVP</router-link> -->
                    <router-link to="/uznemums" class="ds-btn mr-5">Uzņēmuma profils</router-link>
                    <router-link to="/kategorijas" class="ds-btn mr-5">Uzņēmuma kategorijas</router-link>
                </template>

                <a href="javascript:" @click="handleLogout">
                    <font-awesome-icon icon="user" class="mr-1"/> Iziet
                </a>
            </div>
        </div>

        <Alert/>
    </div>
</template>
<script>
    import {mapActions, mapMutations} from 'vuex';
    import {mapGetters} from 'vuex';

    import Alert from '@/components/global/Alert';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import {Company} from '../../vuex/modules/company/models/company.models';

    export default {
        name: 'site-header',
        components: {Alert},
        computed: {
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
            ...mapGetters('company', {
                /** @type {CurrentCompany|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompany: companyStoreTypes.SET_CURRENT_COMPANY,
            }),
            ...mapActions('auth', {
                /** @type {function|*} */
                logout: authStoreTypes.ACTION_LOGOUT,
            }),
            async handleLogout() {
                try {
                    await this.logout();
                    await this.$router.push({name: 'auth'});
                } catch (err) {
                    //
                }
            },
            async handleCategoryTemplates() {
                try {
                    this.setCurrentCompany(new Company);
                    await this.$router.push({name: 'view-template-categories'});
                } catch (err) {
                    //
                }
            },
            async handleOvpJobConditionTemplates() {
                try {
                    this.setCurrentCompany(new Company);
                    await this.$router.push({name: 'view-ovp-job-conditions'});
                } catch (err) {
                    //
                }
            },
            async handleCompanyOvpJobConditionTemplates() {
                try {
                    this.setCurrentCompany(this.currentCompany);
                    await this.$router.push({name: 'view-company-ovp-job-conditions', params: {companyId: this.currentCompany.id}});
                } catch (err) {
                    //
                }
            },
            async handleCompanyOvp() {
                try {
                    await this.$router.push({name: 'view-company-ovp' })
                } catch (err) {
                    //
                }
            },
            async handleCompanyMainPage() {
                try {
                    this.setCurrentCompany(this.currentCompany);
                    await this.$router.push({name: 'view-company', params: {companyId: this.currentCompany.id}});
                } catch (err) {
                    //
                }
            },
        }
    }
</script>